import backend from '@common/backend';

const BASE = '/admins';

export interface IGetAdminsQuery {
	search?: string;
	page?: number;
	limit?: number;
}

export const getAdmins = async (query: IGetAdminsQuery) => backend.get(`${BASE}/`, {
	params: query,
});

export const createAdmin = async (data: any) => backend.post(`${BASE}`, data);

export const getAdmin = async (id: number) => backend.get(`${BASE}/${id}`);

export const removeAdmin = async (id: number) => backend.delete(`${BASE}/${id}`);

export const saveAdmin = async (id: number, data: any) => backend.post(`${BASE}/${id}`, data);
